"use strict";

exports.__esModule = true;
exports.AdVerification = void 0;
var _Event = require("../internal/Event");
var _YoLog = require("../Utils/YoLog");
var _StringUtils = require("../Utils/StringUtils");
var _VerificationEventHandler = require("../Public/VerificationEventHandler");
var _Resource = require("./Resource");
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/**
 * Represents an ad verification object.
 *
 * Encapsulates the data from the `<AdVerification>` element of a VAST document: its
 * attributes, parameters and resources.
 * Through {@link VerificationEventHandler} it supports the ability for a client app to signal verification events.
 * 
 * @hideconstructor
 * @see {@link VerificationEventHandler}, which this class implements
 */
var AdVerification = /*#__PURE__*/function (_VerificationEventHan) {
  _inheritsLoose(AdVerification, _VerificationEventHan);
  function AdVerification(advertData) {
    var _this;
    _this = _VerificationEventHan.call(this) || this;

    /** @private */
    _this.vendor = advertData.verificationVendor;
    /** @private */
    _this.resources = advertData.verificationResources;
    /** @private */
    _this.verificationEvents = advertData.verificationEvents;
    /** @private */
    _this.parameters = advertData.verificationParameters;
    /** @private */
    _this.listeners = [];
    /** @private */
    _this.broker = null;
    return _this;
  }
  var _proto = AdVerification.prototype;
  _proto.getAdVerificationEvents = function getAdVerificationEvents() {
    return this.verificationEvents;
  }

  /**
   * @return {string} the VerificationParameters as a `string`
   */;
  _proto.getParameters = function getParameters() {
    return this.parameters;
  }

  /** Returns the resources for the ad verification object. The resources are represented as YOVASTProperty objects.
   *
   * Each resource will be either an ExecutableResource or JavaScriptResource as defined by the VAST specification.
   * An ExecutableResource contains up to two attributes in the VASTProperty object: apiFramework and type.
   *
   * A JavaScriptResource contains up tp two attributes in the VASTProperty object: apiFramework and browserOptional.
   * 
   * @return {Resource} an array of `Resource` objects associated with the AdVerification
   */;
  _proto.getResources = function getResources() {
    return Object.assign([], this.resources);
  }

  /**
   * @return {string} the vendor of the AdVerification as a `string`
   */;
  _proto.getVendor = function getVendor() {
    return this.vendor;
  };
  _proto.isValid = function isValid() {
    return this.vendor && this.resources && this.resources.length > 0 ? true : false;
  };
  _proto.onVerificationEvent = function onVerificationEvent(event, reason) {
    if (this.listeners.length === 0) {
      _YoLog.YoLog.w("No event listeners - can't signal VerificationEvent");
      return;
    }
    var isInteger = Number.isInteger(reason);
    if (reason && !isInteger) {
      // reason is optional so only warn if present
      _YoLog.YoLog.w("onVerificationEvent: reason should be an integer.");
    }
    var report = this.verificationEvents.get(event);
    if (report) {
      if (isInteger && reason) {
        for (var _iterator = _createForOfIteratorHelperLoose(this.listeners), _step; !(_step = _iterator()).done;) {
          var cb = _step.value;
          cb(new _Event.Event(reason));
        }
      }
      this.broker.fireTrackingReport(report);
    }
  };
  _proto.postParse = function postParse(broker, callback) {
    this.broker = broker;
    if (!callback) {
      _YoLog.YoLog.e("postParse: callback was null");
    } else {
      this.listeners.push(callback);
    }
  };
  _proto.toString = function toString() {
    var s = "";
    if (this.verificationEvents.size > 0) {
      s += "\n - Verification events:";
      for (var _iterator2 = _createForOfIteratorHelperLoose(this.verificationEvents), _step2; !(_step2 = _iterator2()).done;) {
        var _step2$value = _step2.value,
          key = _step2$value[0],
          value = _step2$value[1];
        s += "\n " + key + "=" + value;
      }
    }
    var adVerificationStr = "\n--- Ad Verification:\n - Vendor:";
    adVerificationStr += this.vendor;
    adVerificationStr += "\n - Resources:";
    for (var _iterator3 = _createForOfIteratorHelperLoose(this.resources), _step3; !(_step3 = _iterator3()).done;) {
      var resource = _step3.value;
      adVerificationStr += "\n" + (0, _StringUtils.toIndentedString)(resource);
    }
    adVerificationStr += s;
    adVerificationStr += "\n - VerificationParameters:";
    adVerificationStr += this.parameters;
    return adVerificationStr;
  };
  return AdVerification;
}(_VerificationEventHandler.VerificationEventHandler);
exports.AdVerification = AdVerification;